import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import LoginPage from "./Login";
import Header from '../../../04-containers/Header';
import './style.css';

export default class AuthPage extends Component {
	render() {
		return (
			<div className="pages-auth">
				<Header logoOnly={true} to="/"/>
				<Switch>
					<Route path="/auth/login" component={LoginPage}/>
					<Redirect to="/error/404"/>
				</Switch>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/04-containers/_pages/Auth/index.js